
let fePublicImgHost = 'https://statics.classba.cn/prod/fe_public/projects/mini-program-agent/statics/images'
 // 钉钉id
let VUE_APP_API_CORPID = 'ding416d34dad0dd2492f5bf40eda33b7ba0';
const host = window.location.host, protocol = window.location.protocol;
  if (host.indexOf('exp4pad-test.classba.cn') > -1 || host.indexOf('oa-test.songshuai.com') > -1) { // 测试环境
    VUE_APP_API_CORPID = 'ding416d34dad0dd2492f5bf40eda33b7ba0';
  } else if (host.indexOf('exp4pad-pre.classba.cn') > -1 || host.indexOf('oa-pre.songshuai.com') > -1) { // 开发环境
    VUE_APP_API_CORPID = 'dingc6d8691bf2362deeffe93478753d9884';
  } else if (host.indexOf('exp4pad.classba.cn') > -1 || host.indexOf('oa.songshuai.com') > -1) { // 正式环境
    fePublicImgHost = 'https://statics.classba.cn/prod/fe_public/projects/mini-program-agent/statics/images'
    VUE_APP_API_CORPID = 'dingc6d8691bf2362deeffe93478753d9884';

  } else {

  }

export{
  fePublicImgHost,
  VUE_APP_API_CORPID
}
